import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notificationFields", "workflowFields"];

  toggleAction(event) {
    const value = event.target.value;
    if (this.hasNotificationFieldsTarget) {
      this.notificationFieldsTarget.classList.toggle("no-show", value !== "send_notification");
    }
    if (this.hasWorkflowFieldsTarget) {
      this.workflowFieldsTarget.classList.toggle("no-show", value !== "trigger_workflow");
    }
  }
}
